
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";
import LoginPage from "../components/login/LoginComp";
import Navbar from "../components/navbar/Navbar";
import "../components/cart/Cart.css"
import { useEffect } from "react";
import WhatsAppButton from "../components/WhatsappInt";

const Login=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <div className="bg-imagea">
<Navbar/>
 <Banner title="Login"/>
<LoginPage/>

<Footer/>

</div>
    )
}
export default Login;